import React, { useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faIdCard, faUser } from '@fortawesome/free-solid-svg-icons';

import './AvatarMenu.css';
import { useUserContext } from 'store';
import { useHistory } from 'react-router-dom';
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Menu,
  MenuItem,
  withStyles,
} from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { AvatarMenuContent } from '..';

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
    top: '71px !important',
    width: '350px !important',
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
));

export function AvatarMenu() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [user] = useUserContext();
  const history = useHistory();
  const content = AvatarMenuContent();

  const displayName = `${user.name.split(' ')[0]} ${user.name.split(' ')[1]}`;

  return (
    <>
      <Box className="notificationMenu">
        <Button onClick={() => setIsDropdownOpen((prevState) => !prevState)}>
          <Avatar alt="Remy Sharp" className="avatarIcon">
            <FontAwesomeIcon icon={faUser} className="iconAvatar" />
          </Avatar>
          {isDropdownOpen ? (
            <ExpandLess className="icon" />
          ) : (
            <ExpandMore className="icon" />
          )}
        </Button>
      </Box>
      {isDropdownOpen && (
        <StyledMenu
          className="styledMenu"
          open={setIsDropdownOpen}
          onClose={() => setIsDropdownOpen((prevState) => !prevState)}
        >
          <MenuItem className="avatarMenu">
            <Card className="cardPersonalData noHover">
              <CardContent>
                <FontAwesomeIcon
                  icon={faClose}
                  onClick={() => setIsDropdownOpen((prevState) => !prevState)}
                  className="iconCloseMenu"
                />
                <Box className="iconLateralMenu">
                  <FontAwesomeIcon icon={faIdCard} className="iconMenu" />
                  <Box>
                    <p className="titleCardMenu">{displayName}</p>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </MenuItem>
          {content
            .filter((option) => option.active)
            .map((card, index) => (
              <MenuItem
                key={index}
                onClick={() =>
                  card.path.startsWith('/', 0)
                    ? history.push(card.path)
                    : window.open(card.path, '_blank')
                }
              >
                <Card
                  className={
                    card.id !== 'sair' ? 'cardPersonalData' : 'cardLogout'
                  }
                >
                  <CardContent>
                    <Box className="iconLateralMenu">
                      <FontAwesomeIcon
                        icon={card.icon}
                        className={
                          card.id !== 'sair' ? 'iconMenu' : 'iconLogout'
                        }
                      />
                      <Box
                        className="dataCard"
                        display="flex"
                        flexDirection="column"
                      >
                        <p className="titleCardMenu">{card.title}</p>
                        <p className="descriptionCardMenu">
                          {card.description}
                        </p>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </MenuItem>
            ))}
        </StyledMenu>
      )}
    </>
  );
}
